import { InjectionToken } from '@angular/core';

import { PillInputs } from '../interfaces/pill-inputs.interface';

export const PILL_INPUTS = new InjectionToken<PillInputs>('Pill Inputs');
